import React from "react";
import servicesData from "./itSolutionData";
import { ArrowRight } from "lucide-react";
import Card from "../../../components/Card/Card";
interface ITSolutionsProps {
  id: string;
}

const ITSolutions: React.FC<ITSolutionsProps> = ({ id }) => {
  return (
    <section id={id}>
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="text-center mb-12">
          <p className="text-it-solutions-orange uppercase text-sm font-semibold mb-2">
            WHAT WE PROVIDE
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-[28px] font-bold text-it-text-dark">
            IT Solutions
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {servicesData.map((service, index) => (
            <Card key={index} {...service} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ITSolutions;
